module.exports = __webpack_public_path__ + "img/sad-face.d7910393.svg";